import { FC } from "react";
import styled from "@emotion/styled";
import {
  MDSIcon,
  MDSIconKind,
  MDSIconColor,
  MDSText,
  MDSTextColor,
  MDSTextVariant,
  MDSTextWeight,
  MDSCardSlotName,
} from "@/mds";
import { IntegrationItem } from "@/pages/integrations/integrations-page.types";
import { IntegrationItemCard } from "@/pages/integrations/integration-item-card";

export interface Props {
  title: string;
  items: IntegrationItem[];
}

export const IntegrationsSection: FC<Props> = ({ title, items }) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <Wrapper>
      <Title
        variant={MDSTextVariant.TextXs}
        weight={MDSTextWeight.SemiBold}
        color={MDSTextColor.Secondary}
      >
        {title}
      </Title>
      <Container>
        {items.map(item => (
          <CardWrapper key={item.type}>
            <IntegrationCard
              key={item.type}
              title={item.title}
              mdsIcon={item.icon}
              description={item.description}
              onPress={item.onPress}
              isDisabled={!item.isAllowed}
            >
              {item.isEnabled && (
                <MDSIcon
                  kind={MDSIconKind.CheckCircleSolid}
                  color={MDSIconColor.Positive}
                  slot={MDSCardSlotName.RightAddon}
                />
              )}
            </IntegrationCard>
          </CardWrapper>
        ))}
      </Container>
    </Wrapper>
  );
};

const Wrapper = styled.div``;

const CardWrapper = styled.div`
  width: 288px;
  min-height: 100px;
`;

const Title = styled(MDSText)`
  display: flex;
  padding: ${({ theme }) => theme.spacing[4]} ${({ theme }) => theme.spacing[7]}
    ${({ theme }) => theme.spacing[2]} ${({ theme }) => theme.spacing[7]};
  background: ${({ theme }) => theme.colors.background.list.default};
  text-transform: uppercase;
  letter-spacing: 0.24px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: ${({ theme }) => theme.spacing[2]} ${({ theme }) => theme.spacing[3]};
  gap: ${({ theme }) => theme.spacing[2]};
  align-self: stretch;
`;

const IntegrationCard = styled(IntegrationItemCard)``;
